module.exports = __webpack_public_path__ + "static/media/ThoughtsAboutOscar.92bac880.pdf";